import { Notifications } from 'api/userNotifications';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../actions/userNotifications';

export type UserNotifications = {
  notifications: Notifications;
  isFetching?: boolean;
  isLoaded: boolean;
};
export type State = UserNotifications;
export default function currentUser(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    notifications: [],
    isLoaded: false,
  },
  action: Action
) {
  switch (action.type) {
    case 'NOTIFICATIONS_FETCH_REQUEST':
      return { ...state, isFetching: true };

    case 'NOTIFICATIONS_FETCH_SUCCESS':
      return {
        ...state,
        notifications: action.notifications,
        isFetching: false,
        isLoaded: true,
      };

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
